import React, { Component } from 'react'
import VoicePlayer from './voice/VoicePlayer.js'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import HearingIco from 'material-ui/svg-icons/av/hearing'
class Play extends Component {
  state = {
    play: false,
    pause: false
  }

  handleTextChange = event => {
    const text = event.target.value
    this.setState({ text })
  }

  onEnd = () => {
    this.setState({ play: false })
    console.log('end')
  }

  render() {
    return (
      <div style={{display: 'inline-block', marginRight: '10px', verticalAlign: 'sub'}}>
        <FloatingActionButton
          onClick={() => this.setState({ play: true })}
          mini={true}>
          <HearingIco />
        </FloatingActionButton>

        {this.state.play &&
          this.props.text && (
            <VoicePlayer
              play
              pause={this.state.pause}
              text={(this.props.text.split('')).join(',,,,')}
              onEnd={this.onEnd}
            />
          )}
      </div>
    )
  }
}

export default Play



// WEBPACK FOOTER //
// ./src/components/Play.js